<template>
  <div class="mask" v-if="popupShow" @click.stop="close">
    <div class="popup" @click.stop>
      <div class="title">
        <img src="@/imgs/release/tips.png" class="tips" />
        <span>{{ title }}</span>
      </div>
      <div class="content">{{ content }}</div>
      <div class="btns">
        <div class="left btn" @click.stop="close">{{ cancel }}</div>
        <div class="right btn" @click.stop="onConfirm">{{ confirm }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "提示",
    },
    content: {
      type: String,
      default: "您还未进行认证，请前往认证；",
    },
    cancel: {
      type: String,
      default: "取消",
    },
    confirm: {
      type: String,
      default: "确定",
    },
  },
  data() {
    return {
      popupShow: this.isShow,
    };
  },
  watch: {
    isShow(newV) {
      this.popupShow = newV;
    },
  },
  methods: {
    close() {
      this.popupShow = false;
      this.$emit("onClose");
    },
    onConfirm() {
      this.popupShow = false;
      this.$emit("onConfirm");
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  position: absolute;
  background-color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px 32px;
  width: 480px;
  .title {
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-weight: bold;
    .tips {
      width: 21px;
      height: 21px;
      margin-right: 17px;
    }
  }
  .content {
    margin-top: 13px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    margin-left: 38px;
  }
  .btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 49px;
    .btn {
      width: 64px;
      height: 31px;
      text-align: center;
      line-height: 31px;
      border-radius: 2px;
      cursor: pointer;
      &.left {
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: rgba(0, 0, 0, 0.65);
        margin-right: 8px;
      }
      &.right {
        background-color: #1890ff;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup.vue